import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  py: '3x',
  textAlign: 'center',
  gap: '3x',
});

export const illustration = css({
  maxWidth: '200px',
  width: '100%',
  height: 'auto',
});

export const header = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1x',
});

export const title = css({
  fontSize: 'lg',
  fontWeight: 'bold',
  color: 'hpxBlue600',
});

export const body = css({
  fontSize: 'md',
  color: 'hpxBlue500',
  lineHeight: '1.5',
  maxWidth: '400px',
});

export const buttonContainer = css({
  width: '100%',
  maxWidth: '300px',
});
